import { render, staticRenderFns, recyclableRender, components } from "./bargainProduct.vue?vue&type=template&id=4f8e3869&"
var renderjs
import script from "./bargainProduct.vue?vue&type=script&lang=js&"
export * from "./bargainProduct.vue?vue&type=script&lang=js&"
import style0 from "./bargainProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/diy/bargainProduct/bargainProduct.vue"
export default component.exports